export default "__VITE_ASSET__82c5c282__"